const getEnv = (envName: string): string => {
  const env = process.env[envName];
  if (!env) throw new Error(`${envName} is not defined.`);
  return env;
};

export type PortalVariant = "accountant" | "customer";

export const CLIENT_VERSION = getEnv("REACT_APP_VERSION");

export const gettingStartedMaxClients = 5;
export const variant = getEnv("REACT_APP_PORTAL_VARIANT") as PortalVariant;

// List of feature flags supported by the portal. These feature flags are defined in the
// backend through the Django-admin under "django-waffle".
export const FEATURE_FLAGS = {
  showAccountantTaxTab: "portal.show_accountant_tax_tab",
  webAddBankAccounts: "web.add_bank_accounts",
  showMtdTab: "portal.show_mtd_tab",
  showAccountantMtdConnect: "portal.show_accountant_mtd_connect",
  showMtdInfo: "portal.show_mtd_feature_stub",
  showReceiptsTab: "portal.show_receipts_tab",
  showChargebeeManage: "portal.show_chargebee_manage_feature",
  showMTDAnnualSubmission: "mtd.annual_submission",
  hideTransactionsEnabled: "portal.hide_transactions_enabled",
  showMtdBridgingPlan: "portal.show_mtd_bridging_plan",
};

export const typeformFormIds = {
  mtdFeature: "yFsIKhzo",
};

const customerWebHost =
  process.env.NODE_ENV === "production"
    ? "https://web.getcoconut.com"
    : "http://localhost:3000";

const accountantWebHost =
  process.env.NODE_ENV === "production"
    ? "https://accountant.getcoconut.com"
    : "http://localhost:3000";

export const currentWebRoot =
  variant === "customer" ? customerWebHost : accountantWebHost;

// Global config defaults - can be overridden on a per-query basis.
// Don't retry responses that won't change on retry, e.g. an advisor without
// the MTD access their firm admin must grant (403), or no usable firm admin
// HMRC connection (409). Otherwise keep react-query's default of 3 retries.
const NON_RETRYABLE_STATUSES = [403, 409];
const MAX_QUERY_RETRIES = 3;

export const reactQueryConfig = {
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 15,
      cacheTime: 1000 * 60 * 60 * 24,
      refetchOnWindowFocus: false,
      retry: (failureCount: number, error: unknown) => {
        const status = (error as { response?: { status?: number } })?.response
          ?.status;
        if (status && NON_RETRYABLE_STATUSES.includes(status)) {
          return false;
        }
        return failureCount < MAX_QUERY_RETRIES;
      },
    },
  },
};

export const ACCOUNT_SERVICE_BASE_URL =
  process.env.REACT_APP_ACCOUNT_SERVICE_URL;
